import { useRouter } from 'next/router';
import React from 'react';
import DashboardPage from '../../../components/Dashboard/DashboardPage';
import Hosting from '../../../components/Dashboard/Hosting';
import withApollo from '../../../lib/withApollo';

const HostingPage = () => {
  const router = useRouter();

  const { open, paymentSuccess, blogId } = router.query;
  return (
    <DashboardPage
      open={open}
      label="hosting"
      content={
        <Hosting page={4} paymentSuccess={paymentSuccess} blogId={blogId} />
      }
    />
  );
};

export default withApollo(HostingPage);
